import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {updateBeerData} from 'services/beers';
import {setSuccessAC} from 'store/app/appSlice';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import {Beer} from 'typescript/models/Beer';

import {setUpdatedBeerAC} from '../beerSlice';
import {updateSingleBeerACS} from '../requestAC';

export function* updateBeer(action: ReturnType<typeof updateSingleBeerACS>) {
  const {id, data} = action.payload;

  try {
    const response: AxiosResponse<ApiData<Beer>> = yield call(updateBeerData, id, data);
    yield put(setUpdatedBeerAC(response.data.data));
    yield put(setSuccessAC('Beer updated successfully'));
  } catch (error) {
    yield call(handleError, error, 'Failed to update beer');
  }
}
